const translations = {
  "en": {
    "Maybe later": "Maybe later",
    "See what you should do": "See what you should do",
    "Setup goal": "Setup goal",
    "Setup plan": "Setup plan",
    "Unlock full plan": "Unlock full plan",
    "View my goal": "View my goal"
  },
  "zh-tw": {
    "Maybe later": "暫不",
    "See what you should do": "看看你應該做什麼",
    "Setup goal": "設定目標",
    "Setup plan": "設定計畫",
    "Unlock full plan": "解鎖完整計畫",
    "View my goal": "查看我的目標"
  }
};

export default translations;
